import axios from 'axios';
import { getTrimmedFirstString } from '../util';

class ServiceCredibility {
  getCachedCreditsafeDetails = async (organizationNumber) => {
    const response = await axios.get(
      '/api/creditsafe/cached-details',
      { params: { organizationNumber } }
    );
    return response?.data;
  }

  getCreditsafeDetails = async (organizationNumber) => {
    const response = await axios.get(
      '/api/creditsafe/details',
      { params: { organizationNumber } }
    );
    return response?.data;
  }

  downloadCreditsafePdf = async (organizationNumber) => {
    const response = await axios.get(
      '/api/creditsafe/pdf',
      {
        responseType: 'blob',
        headers: {
          Accept: 'application/pdf',
          'Content-Type': 'application/pdf',
        },
        params: { organizationNumber },
      }
    );
    return response;
  }

  getCompanyData = async (orgNum, supplierId) => {
    try {
      return await axios.get(
        '/api/credibility/company',
        { params: { regNum: orgNum, supplierId } }
      );
    } catch (error) {
//      console.error('Company data fetch failed', error);
      return null;
    }
  };

  getTicDetails = async (organizationNumber, excludeExtraneousData) => {
    const response = await axios.get(
      '/api/tic/details',
      { params: { organizationNumber, excludeExtraneousData } }
    );
    return response?.data;
  }

  signupTicCustomer = async (email) => {
    const response = await axios.post(
      '/api/tic/signup',
      { email }
    );
    return response?.data;
  }

  filterSynaCompanyData = (compData) => {
    const addressList = compData.Objekt?.Omfragad?.Adresslista;
    const name = compData.Objekt?.Omfragad?.Namnlista?.Namn?._text;
    let street, postalCode, city;
    const municipality = compData.Objekt?.Omfragad?.Bolsate?._text && getTrimmedFirstString(compData.Objekt?.Omfragad?.Bolsate._text);

    if (addressList) {
      let address = addressList.Adress;
      if (Array.isArray(address) && address.length) {
        address = address.find(item => item?._attributes?.typ === 'sate') || address[address.length-1];
      }
      street = address?.Gatabox?._text;
      postalCode = address?.Postnr?._text;
      city = address?.Postort?._text;
    }
    return this.composeCompanyDataResult(name, street, postalCode, city, municipality);
  };

  filterCreditsafeCompanyData = (compData) => {
    const { address, name } = compData;
    return this.composeCompanyDataResult(name, address?.street, address?.postCode, address?.city?.toString());
  };

  filterTicCompanyData = (compData) => {
    const name = (compData.names?.find((name) => name.companyNamingType === 'legalName') ?? compData.names?.[0])?.nameOrIdentifier;
    const address = compData.mostRecentMailingAddress;
    return this.composeCompanyDataResult(name, address?.streetAddress, address?.postalCode, address?.city);
  };

  composeCompanyDataResult = (name, street, postalCode, city, municipality) => {
    return {
      name: name || '',
      kommun: municipality || city || '',
      address: `${street || ''}
${postalCode ? postalCode+' ' : ''}${city || ''}`,
      postnumber: postalCode,
    };
  }
}

export default new ServiceCredibility();
